import { r as registerInstance, c as createEvent, h, g as getElement } from './index-16dc7dde.js';
import { m as myProductsResponseStatus, E as EAvailabilityType, a as EApcButtonType } from './request.constants-deb285e0.js';
import { at as productCtasColors, as as productCtasButtonType, e as getDataAttributes } from './utils-15ad90ec.js';
import './lookups-705fb53e.js';
import { j as join } from './path-9b025204.js';
import { p as parseCommonURLToRouterParts } from './url-parser-fe899a81.js';
import { s as send, r as removeFromFavoritesEvent, D as addToCartRelatedProductsEvent } from './send-33ade633.js';
import { i as isAnalyticsEnabled } from './helpers-71d81730.js';
import { c as classnames } from './index-136476ff.js';
import { a as addToCart } from './api-413e09d4.js';
import { b as isProductInMyProducts } from './utils-c23b708f.js';
import { P as PesRoute } from './pes-route-63457678.js';
import { i as isAppRoutingEnabled, b as getIsProductsInCustomCart, j as getCustomProductCTAs, n as navigateWithRouter } from './utils-60b2d521.js';
import './tslib.es6-2af8cb53.js';
import './_commonjsHelpers-ba3f0406.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';
import './analytics-765d4daf.js';
import './pes-router-store-1a105b49.js';
import './index-634d378a.js';
import './utils-913bdf8a.js';
import './http-fdc7ba18.js';
import './isEmpty-b60327cb.js';
import './isTypedArray-dfccd669.js';
import './controller-0b53c447.js';
import './format-string-a043c0ab.js';
import './toString-da636857.js';
import './flatMap-bcae5f36.js';
import './_baseFlatten-2670ede5.js';
import './identity-6651b537.js';
import './_baseIteratee-506bcd8a.js';
import './_Uint8Array-2e849395.js';
import './_baseTimes-db8626dd.js';
import './hasIn-6ce0da41.js';

const webUIColors = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};
const webUIOptions = {
  FLAT: 'flat',
  OUTLINE: 'outline',
};
const DEFAULT_WEB_UI_BUTTON_COLOR_OPTION = {
  color: webUIColors.SECONDARY,
  option: webUIOptions.OUTLINE,
};
const uiaasToWebUIButtonColor = (styleName) => {
  if (styleName === null || styleName === void 0 ? void 0 : styleName.endsWith('green')) {
    return webUIColors.PRIMARY;
  }
  if (styleName === null || styleName === void 0 ? void 0 : styleName.endsWith('blue')) {
    return webUIColors.SECONDARY;
  }
};
const uiaasToWebUIButtonOption = (styleName) => {
  if (styleName === null || styleName === void 0 ? void 0 : styleName.startsWith('primary')) {
    return webUIOptions.FLAT;
  }
  if (styleName === null || styleName === void 0 ? void 0 : styleName.startsWith('secondary')) {
    return webUIOptions.OUTLINE;
  }
};
const uiaasToWebUIButtonsStyle = (styleName) => {
  if (!Object.values(productCtasColors).includes(styleName)) {
    return DEFAULT_WEB_UI_BUTTON_COLOR_OPTION;
  }
  return {
    color: uiaasToWebUIButtonColor(styleName === null || styleName === void 0 ? void 0 : styleName.toLowerCase()),
    option: uiaasToWebUIButtonOption(styleName === null || styleName === void 0 ? void 0 : styleName.toLowerCase()),
  };
};

const productCardCss = ":host{display:block}:host(:not([dir=\"rtl\"])){text-align:left}:host([dir=\"rtl\"]){text-align:right}.related-product-card{position:relative}@media screen and (min-width: 980px){.related-product-card{display:flex}}.related-product-card__link{display:flex;text-decoration:none;font-weight:normal;min-height:100px}@media screen and (min-width: 980px){.related-product-card__link{flex:1;box-sizing:border-box;position:relative;z-index:1}}.related-product-card__controls{display:flex;flex-direction:column;justify-content:center}@media screen and (max-width: 979px){.related-product-card__controls{padding-top:12px}}@media screen and (min-width: 980px){.related-product-card__controls{min-width:215px}:host(:not([dir=\"rtl\"])) .related-product-card__controls{margin-left:10px}:host([dir=\"rtl\"]) .related-product-card__controls{margin-right:10px}}.related-product-card__img{-o-object-fit:contain;object-fit:contain}@media screen and (max-width: 979px){.related-product-card__img{width:70px;height:70px;margin-bottom:10px}:host(:not([dir=\"rtl\"])) .related-product-card__img{margin-right:10px}:host([dir=\"rtl\"]) .related-product-card__img{margin-left:10px}}@media screen and (min-width: 980px){.related-product-card__img{width:100px;height:100px}:host(:not([dir=\"rtl\"])) .related-product-card__img{margin-right:20px}:host([dir=\"rtl\"]) .related-product-card__img{margin-left:20px}}.related-product-card__title{font-weight:bold;color:#333333}@media screen and (max-width: 979px){.related-product-card__title{font-size:14px;line-height:1.4285714286}}@media screen and (min-width: 980px){.related-product-card__title{font-size:14px;line-height:1.7142857143;padding-top:16px}}.related-product-card__link:hover .related-product-card__title{text-decoration:underline}.related-product-card__description{color:#333333;margin-top:8px;font-size:12px;line-height:1.3333333333}.related-product-card__price{font-weight:normal}@media screen and (max-width: 979px){.related-product-card__price{order:-1;font-size:16px;padding-bottom:10px}}@media screen and (min-width: 980px){.related-product-card__price{text-align:center;font-size:14px;padding-top:12px}}.related-product-card__price-value{font-weight:bold}@media screen and (min-width: 980px){.related-product-card__price-value{font-size:18px}}.related-product-card__button+.related-product-card__button{margin-top:10px}";

let RelatedProductCard = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.ctaClick = createEvent(this, "ctaClick", 7);
    this.productCardClicked = createEvent(this, "productCardClicked", 7);
    this.myProducts = [];
    this.inCart = false;
    this.isApc = Boolean(window.isApc);
    this.setInCart = () => {
      var _a, _b, _c, _d;
      if (!isAppRoutingEnabled()) {
        if (!this.myProducts || this.myProducts.length === 0) {
          this.inCart = false;
          return;
        }
        this.inCart = isProductInMyProducts({ [(_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.skuId]: 1 }, this.myProducts);
      }
      else {
        this.inCart = getIsProductsInCustomCart([(_d = (_c = this.product) === null || _c === void 0 ? void 0 : _c.product) === null || _d === void 0 ? void 0 : _d.skuId]);
      }
    };
    this.onProductCardClicked = () => {
      var _a, _b;
      this.productCardClicked.emit((_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.skuId);
    };
    this.getAnalyticData = (buttonType) => {
      var _a, _b;
      const { skuId: id, description } = (_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.product) !== null && _b !== void 0 ? _b : {};
      const { currency: currencyCode = '', price = null, brand = '' } = this.product;
      const product = {
        id,
        price,
        brand,
        name: description,
        category: '',
        quantity: 1,
      };
      if (buttonType === productCtasButtonType.FAVORITES && this.inCart) {
        return {
          currencyCode,
          products: [product],
        };
      }
      return {
        currencyCode,
        relatedSectionId: this.groupId,
        distributor: '',
        products: [Object.assign(Object.assign({}, product), { variant: this.productId })],
      };
    };
    this.sendAnalytics = (buttonType) => {
      switch (buttonType) {
        case productCtasButtonType.CART:
          send(addToCartRelatedProductsEvent, this.getAnalyticData(buttonType));
          break;
        case productCtasButtonType.FAVORITES:
          if (this.inCart) {
            send(removeFromFavoritesEvent, this.getAnalyticData(buttonType));
          }
          else {
            send(addToCartRelatedProductsEvent, this.getAnalyticData(buttonType));
          }
          break;
      }
    };
    this.getOnCTAClickHandler = (productId, buttonType, inCart) => (event) => {
      const commonProps = {
        initialEvent: event,
        type: buttonType,
        product: {
          id: productId,
        },
        bannerContext: 'body',
      };
      if (buttonType === productCtasButtonType.CART
        || buttonType === productCtasButtonType.FAVORITES) {
        this.ctaClick.emit(Object.assign(Object.assign({}, commonProps), { inList: inCart, onFinish: (result) => {
            if ((result === null || result === void 0 ? void 0 : result.status) === myProductsResponseStatus.SUCCESS) {
              this.inCart = !this.inCart;
            }
          } }));
        if (isAnalyticsEnabled()) {
          this.sendAnalytics(buttonType);
        }
        return;
      }
      this.ctaClick.emit(Object.assign({}, commonProps));
    };
    this.ctaToComponents = (cta) => {
      return Object.keys(cta.buttons).map((buttonType) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        const buttonSettings = cta.buttons[buttonType];
        if (!buttonSettings.isShown) {
          return null;
        }
        const { color, option } = uiaasToWebUIButtonsStyle(buttonSettings.color);
        const inCart = ((_a = buttonSettings.list) === null || _a === void 0 ? void 0 : _a.includes((_c = (_b = this.product) === null || _b === void 0 ? void 0 : _b.product) === null || _c === void 0 ? void 0 : _c.skuId)) || false;
        const commonProps = Object.assign({ className: 'related-product-card__button', block: true, size: this.isMobile ? 'large' : 'medium', padding: 'none', option,
          color, onClick: this.getOnCTAClickHandler((_e = (_d = this.product) === null || _d === void 0 ? void 0 : _d.product) === null || _e === void 0 ? void 0 : _e.skuId, buttonType, inCart) }, getDataAttributes(buttonSettings.dataset));
        if (buttonType === productCtasButtonType.FAVORITES) {
          const isInFavorites = buttonSettings.list.includes((_g = (_f = this.product) === null || _f === void 0 ? void 0 : _f.product) === null || _g === void 0 ? void 0 : _g.skuId);
          return (h("se-button", Object.assign({}, commonProps, { icon: buttonSettings.icons[isInFavorites ? 'removeIcon' : 'addIcon'] }), isInFavorites
            ? buttonSettings.labels.removeLabel
              || ((_h = this.secondaryCTALabels) === null || _h === void 0 ? void 0 : _h.removeFromFavoritesLabel)
              || ((_j = this.product) === null || _j === void 0 ? void 0 : _j.removeFromCartLabel)
            : buttonSettings.labels.addLabel
              || ((_k = this.secondaryCTALabels) === null || _k === void 0 ? void 0 : _k.addToFavoritesLabel)
              || ((_l = this.product) === null || _l === void 0 ? void 0 : _l.addToCartLabel)));
        }
        if (buttonType === productCtasButtonType.CART) {
          return (h("se-button", Object.assign({}, commonProps, { icon: buttonSettings.icons.addIcon }), buttonSettings.labels.addLabel
            || ((_m = this.secondaryCTALabels) === null || _m === void 0 ? void 0 : _m.addToCartLabel)
            || ((_o = this.product) === null || _o === void 0 ? void 0 : _o.addToCartLabel)));
        }
        return (h("se-button", Object.assign({}, commonProps, { icon: buttonSettings.icon }), buttonSettings.label));
      });
    };
    this.buildCTAButtonByResponse = () => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
      const commonProps = {
        isShown: true,
        color: productCtasColors.SECONDARY_BLUE,
      };
      if (this.cartTransferEnabled) {
        return {
          buttons: {
            [productCtasButtonType.CART]: Object.assign(Object.assign({}, commonProps), { list: this.inCart ? [(_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.skuId] : [], icons: {
                addIcon: 'segment_retail',
                removeIcon: 'segment_retail',
              }, labels: {
                addLabel: ((_c = this.secondaryCTALabels) === null || _c === void 0 ? void 0 : _c.addToCartLabel) || ((_d = this.product) === null || _d === void 0 ? void 0 : _d.addToCartLabel),
                removeLabel: ((_e = this.secondaryCTALabels) === null || _e === void 0 ? void 0 : _e.addToCartLabel) || ((_f = this.product) === null || _f === void 0 ? void 0 : _f.addToCartLabel),
              } }),
          },
        };
      }
      return {
        buttons: {
          [productCtasButtonType.FAVORITES]: Object.assign(Object.assign({}, commonProps), { list: this.inCart ? [(_h = (_g = this.product) === null || _g === void 0 ? void 0 : _g.product) === null || _h === void 0 ? void 0 : _h.skuId] : [], icons: {
              addIcon: 'star_stroke',
              removeIcon: 'star_plain',
            }, labels: {
              addLabel: ((_j = this.secondaryCTALabels) === null || _j === void 0 ? void 0 : _j.addToFavoritesLabel) || ((_k = this.product) === null || _k === void 0 ? void 0 : _k.addToCartLabel),
              removeLabel: ((_l = this.secondaryCTALabels) === null || _l === void 0 ? void 0 : _l.removeFromFavoritesLabel)
                || ((_m = this.product) === null || _m === void 0 ? void 0 : _m.removeFromCartLabel),
            } }),
        },
      };
    };
    this.renderCTAButtons = () => {
      return this.ctaToComponents(getCustomProductCTAs() || this.buildCTAButtonByResponse());
    };
    this.shouldShowPrice = () => {
      return Boolean(this.product.prpPriceLabel && this.product.price && this.product.currency);
    };
    this.getApcPrices = (productId) => {
      var _a, _b;
      if (!productId) {
        return null;
      }
      if (!((_b = (_a = this.productAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.prices) === null || _b === void 0 ? void 0 : _b[productId])) {
        return null;
      }
      const { priceLabel, previousPriceValue, VATInclused, previousPrice, activePrice, activePriceNoTax, activePriceValue, } = this.productAvailabilityInfo.prices[productId];
      return {
        priceLabel,
        previousPriceValue,
        VATInclused,
        previousPrice,
        activePrice,
        activePriceNoTax,
        activePriceValue,
      };
    };
    this.getActivePrice = (productId) => {
      return this.renderApcPrices(productId);
    };
    this.linkClickHandler = (event) => {
      if (isAppRoutingEnabled()) {
        event.preventDefault();
        navigateWithRouter(this.route, event.currentTarget);
        if (this.onProductClick) {
          this.onProductClick(this.productId);
        }
        return;
      }
      this.onProductCardClicked();
    };
    this.getButtonType = (productId) => {
      var _a, _b;
      const availabilityType = ((_b = (_a = this.productAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.availability) === null || _b === void 0 ? void 0 : _b[productId !== null && productId !== void 0 ? productId : '']) || null;
      switch (availabilityType) {
        case EAvailabilityType.ADD_TO_CART:
        case EAvailabilityType.PURCHASE_CD:
          return EApcButtonType.ADD_TO_CART;
        default:
          return null;
      }
    };
    this.handleClick = (event, productId) => {
      var _a, _b, _c, _d;
      addToCart(event, productId, this.getLocaleCodes(), (_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.apcHost, (_d = (_c = this.apcCta) === null || _c === void 0 ? void 0 : _c.labels) === null || _d === void 0 ? void 0 : _d.failedResponse, this.agentChatCscId);
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    this.setInCart();
    this.mediaQuery = window.matchMedia('(max-width: 979px)');
    this.isMobile = this.mediaQuery.matches;
    this.mediaQuery.addEventListener('change', (e) => {
      this.isMobile = e.matches;
    });
    if (isAppRoutingEnabled()) {
      const { pageType, pageId } = parseCommonURLToRouterParts(this.product.url);
      this.route = new PesRoute({ page: pageType, pageId });
      this.product.url = this.route.url;
    }
  }
  onCcGetOptionsSucceeded(event) {
    if (event.detail.isApcSite && event.detail.agentChatCscId) {
      this.agentChatCscId = event.detail.agentChatCscId;
    }
  }
  onMyProductsChange() {
    this.setInCart();
  }
  renderApcPrices(productId) {
    var _a, _b, _c, _d;
    const prices = this.getApcPrices(productId);
    return (prices && (h("pes-cta-price", { class: "cta-area__price", previousPriceVariant: "beside", priceHTML: prices.activePrice, previousPriceHTML: prices.previousPrice, inStockLabel: (_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.inStockLabel, vatLabel: (prices === null || prices === void 0 ? void 0 : prices.VATInclused) ? (_d = (_c = this.apcCta) === null || _c === void 0 ? void 0 : _c.labels) === null || _d === void 0 ? void 0 : _d.vatLabel : '', resellerLabel: prices.priceLabel, variant: "list" })));
  }
  renderPrices(productId) {
    return (h("div", { class: classnames('prices', this.isMobile && 'prices--mobile') }, this.getActivePrice(productId)));
  }
  getLocaleCodes() {
    const locale = document.querySelector('body').getAttribute('locale');
    const [languageCode, contryCode] = locale.split('_');
    return contryCode && languageCode
      ? join('/', contryCode.toLowerCase(), languageCode.toLowerCase())
      : '';
  }
  renderApcAddToCartButton(productId) {
    var _a, _b;
    const addToCartButtonLabel = ((_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.addToCartButtonLabel) || 'Add to Cart';
    return (this.getButtonType(productId) && (h("pes-cta-button", { class: "cta-area__button", type: "primary", size: "medium", icon: "segment_retail", onDidClick: (event) => this.handleClick(event.detail, productId) }, addToCartButtonLabel)));
  }
  renderPrimaryCTA(productId) {
    return this.renderApcAddToCartButton(productId);
  }
  renderCTAArea(productId) {
    return (h("div", { class: "cta-area" }, h("div", { class: "cta-area__buttons" }, this.renderPrimaryCTA(productId))));
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return (h("div", { class: "related-product-card" }, h("a", { class: "related-product-card__link", href: this.product.url, onClick: this.linkClickHandler }, h("img", { src: (_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.imageLink.url, alt: (_d = (_c = this.product) === null || _c === void 0 ? void 0 : _c.product) === null || _d === void 0 ? void 0 : _d.imageLink.title, class: "related-product-card__img", loading: "lazy" }), h("div", { class: "related-product-card__body" }, h("div", { class: "related-product-card__title" }, (_f = (_e = this.product) === null || _e === void 0 ? void 0 : _e.product) === null || _f === void 0 ? void 0 : _f.description), h("div", { class: "related-product-card__description" }, (_h = (_g = this.product) === null || _g === void 0 ? void 0 : _g.product) === null || _h === void 0 ? void 0 : _h.name))), h("div", { class: "related-product-card__controls" }, !this.isApc && this.renderCTAButtons(), !this.isApc && this.shouldShowPrice() && (h("div", { class: "related-product-card__price" }, `${this.product.prpPriceLabel}: `, h("span", { class: "related-product-card__price-value" }, `${this.product.price} ${this.product.currency}`))), this.productAvailabilityInfo && this.isApc && (h("div", null, h("div", { class: "price-cta-container" }, this.renderPrices((_k = (_j = this.product) === null || _j === void 0 ? void 0 : _j.product) === null || _k === void 0 ? void 0 : _k.name)), h("div", { class: "cta-area__row cta-area__price-container" }, this.renderCTAArea((_m = (_l = this.product) === null || _l === void 0 ? void 0 : _l.product) === null || _m === void 0 ? void 0 : _m.name)))))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "myProducts": ["onMyProductsChange"]
  }; }
};
RelatedProductCard.style = productCardCss;

const dialogCss = ":host{display:block}@media screen and (max-width: 979px){.related-product-dialog{padding:10px 0}}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .related-product-dialog{padding:0 25px 10px 40px}:host([dir=\"rtl\"]) .related-product-dialog{padding:0 40px 10px 25px}}@media screen and (max-width: 979px){.related-product-dialog__card{padding:20px 25px}}@media screen and (min-width: 980px){.related-product-dialog__card{padding-top:10px;padding-bottom:10px}}.related-product-dialog__card+.related-product-dialog__card{border-top-style:solid;border-top-color:#f3f2f2}@media screen and (max-width: 979px){.related-product-dialog__card+.related-product-dialog__card{border-top-width:2px}}@media screen and (min-width: 980px){.related-product-dialog__card+.related-product-dialog__card{border-top-width:1px}}";

let RelatedProductsDialog = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  didPricesLoad(event) {
    if (event.detail) {
      this.productAvailabilityInfo = event.detail;
    }
  }
  render() {
    return (h("se-dialog", { open: this.isOpen, size: "xlarge" }, h("se-dialog-header", { "close-icon": true }, this.header), h("se-dialog-content", { option: "fill" }, h("div", { class: "related-product-dialog" }, this.products.map((product) => (h("pes-related-product-card", { class: "related-product-dialog__card", secondaryCTALabels: this.secondaryCTALabels, product: product, cartTransferEnabled: this.cartTransferEnabled, myProducts: this.myProducts, groupId: this.groupId, productId: this.productId, onProductClick: this.onProductClick, key: product.product.skuId, productAvailabilityInfo: this.productAvailabilityInfo, apcCta: this.apcCta })))))));
  }
};
RelatedProductsDialog.style = dialogCss;

export { RelatedProductCard as pes_related_product_card, RelatedProductsDialog as pes_related_products_dialog };
